type LatencyTimeKeeper = {
  getMeasureDurationSecs: () => number;
  measureDurationAt: (index: number) => number;
};

export const getInputLatencyMeasureOffset = (
  timeKeeper: LatencyTimeKeeper | null | undefined,
  inputLatencyMs?: number | null,
) => {
  const latencyMs =
    typeof inputLatencyMs === 'number' && Number.isFinite(inputLatencyMs)
      ? Math.max(0, inputLatencyMs)
      : 0;
  if (!timeKeeper || latencyMs <= 0) return 0;

  const measureDurationSecs = timeKeeper.getMeasureDurationSecs();
  const measureFrac = timeKeeper.measureDurationAt(0);
  if (
    !Number.isFinite(measureDurationSecs) ||
    measureDurationSecs <= 0 ||
    !Number.isFinite(measureFrac) ||
    measureFrac <= 0
  ) {
    return 0;
  }

  return (latencyMs / 1000 / measureDurationSecs) * measureFrac;
};

export const getLatencyAdjustedMeasureTimestamp = (
  timestamp: number,
  timeKeeper: LatencyTimeKeeper | null | undefined,
  inputLatencyMs?: number | null,
) => timestamp - getInputLatencyMeasureOffset(timeKeeper, inputLatencyMs);
